<h1 mat-dialog-title [innerHTML]="data.title"></h1>

<form [formGroup]="formGroup">
  <div mat-dialog-content>
    <mat-form-field class="w-400">
      <mat-label>{{data.formControlLabel}}</mat-label>
      <input matInput formControlName="formControl" (focus)="onFocus()"/>
    </mat-form-field>
    @if (formGroup.get('formControl')?.touched && formGroup.get('formControl')?.invalid) {
      <div class="validation-error">{{data.validationErrorMessage}}</div>
    }
  </div>

  <div mat-dialog-actions>
    <button type="button" mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
    <button type="button" mat-button (click)="onCancel()">Cancel</button>
  </div>
</form>